<template>
  <v-container fluid>
    <div class="text-h2">
      Resumen de compra
    </div>

    <v-subheader>
      Número de pedido <br />
      {{ this.puchase_data.orderNumber }}
    </v-subheader>

    <v-subheader>
      Fecha y hora <br />
      {{ this.puchase_data.orderDate }}
    </v-subheader>

    <v-subheader>
      Nombre y apellido <br />
      {{ this.puchase_data.userFullName }}
    </v-subheader>

    <v-subheader>
      Tarjeta de crédito/debito<br />
      {{ this.puchase_data.cardData }}
    </v-subheader>

    <v-subheader>
      Importe de la transacción <br />
      {{ this.puchase_data.currencyType }}
      {{ this.puchase_data.purchaseAmount }}
    </v-subheader>

    <v-subheader>
      Detalle <br />
      {{ this.puchase_data.purchaseDescription }}
    </v-subheader>

    <modal-button
      :tutorial="this.tutorial"
      :label="this.text"
      :button_style="1"
    />
  </v-container>
</template>

<script>
import ModalButton from "@/views/dashboard/pages/home/ModalButton";

export default {
  components: {
    ModalButton
  },
  data() {
    return {
      tutorial: "terms",
      text: "Términos y Condiciones",
      puchase_data: {
        orderNumber: this.$route.query.ordenNumber,
        orderDate: new Date(parseInt(this.$route.query.date)),
        userFullName: this.$route.query.name,
        cardData: this.$route.query.cardData,
        // cardBrand: this.$route.query.cardBrand,
        currencyType: this.$route.query.currency,
        purchaseAmount: this.$route.query.amount,
        purchaseDescription: this.$route.query.description
      }
    };
  },
  computed: {
    //...mapState(["user"])
  },
  mounted() {
    // this.uid = this.user.uid;
    //console.log("purchase data: ",puchase_data);
  } /*,
  methods: {
    beforeRouteEnter (to, from, next) {

      //console.log("router: ", from.path, to.path, auth.currentUser);

      next(async vm => {
        const user = vm.user
        if (user.type === 'tutor' || user.type === 'parent') {
          vm.viewPage = true
          next()
        } else {
          console.log('Página no autorizada.')
          next({
            name: 'Home',
          })
        }
      })
    },
  }*/
};
</script>
